"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultOptions = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var deepmerge_1 = __importDefault(require("deepmerge"));
var react_1 = __importDefault(require("react"));
var core_1 = require("../../shared/core");
var analytics_subjects_1 = require("./analytics-subjects");
var utils_1 = require("./utils");
var Prompt = function (_a) {
    var _b;
    var children = _a.children, showBanner = _a.showBanner;
    return showBanner ? (react_1.default.createElement(ui_tools_1.AnalyticsView, { name: analytics_subjects_1.USAGE_METER_READ_PROMPT, properties: (_b = {}, _b[core_1.INTERNAL_EVENT_FLAG] = true, _b) },
        react_1.default.createElement("span", null, children))) : null;
};
var PromptLink = function (_a) {
    var _b;
    var children = _a.children, fuel = _a.fuel;
    var TextLink = (0, core_1.useComponents)().TextLink;
    var meterReadsNew = (0, core_1.useLinks)().meterReadsNew;
    var meterReadsUrl = fuel === 'both' ? meterReadsNew() : meterReadsNew({ fuelType: fuel });
    return (react_1.default.createElement(ui_tools_1.AnalyticsClick, { name: analytics_subjects_1.USAGE_SEND_METER_READ, properties: (_b = {}, _b[core_1.INTERNAL_EVENT_FLAG] = true, _b) },
        react_1.default.createElement(TextLink, { href: meterReadsUrl, "data-testid": "meter-reading-link" }, children)));
};
var ReadingDate = function (lastRead) {
    if (lastRead && (0, utils_1.readIsAboveThreshold)(lastRead.lastActualRead)) {
        return (react_1.default.createElement("span", { "data-testid": "last-submitted-read-date" }, (0, utils_1.formatReadingDate)(lastRead.lastActualRead)));
    }
    else {
        return null;
    }
};
var ReadingElecDate = function (_a) {
    var lastActualElecRead = _a.lastActualElecRead;
    if (lastActualElecRead && (0, utils_1.readIsAboveThreshold)(lastActualElecRead)) {
        return (react_1.default.createElement("span", { "data-testid": "last-submitted-read-date-elec" }, (0, utils_1.formatReadingDate)(lastActualElecRead)));
    }
    else {
        return null;
    }
};
var ReadingGasDate = function (_a) {
    var lastActualGasRead = _a.lastActualGasRead;
    if (lastActualGasRead && (0, utils_1.readIsAboveThreshold)(lastActualGasRead)) {
        return (react_1.default.createElement("span", { "data-testid": "last-submitted-read-date-gas" }, (0, utils_1.formatReadingDate)(lastActualGasRead)));
    }
    else {
        return null;
    }
};
var ToDate = function (_a) {
    var children = _a.children, isToDate = _a.isToDate;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        children,
        isToDate && ' to date'));
};
var UnsupportedMeterBillingLink = function (_a) {
    var _b;
    var children = _a.children;
    var TextLink = (0, core_1.useComponents)().TextLink;
    var billingHistory = (0, core_1.useLinks)().billingHistory;
    return (react_1.default.createElement(ui_tools_1.AnalyticsClick, { name: analytics_subjects_1.USAGE_NOT_SUPPORTED_BILLING_LINK, properties: (_b = {}, _b[core_1.INTERNAL_EVENT_FLAG] = true, _b) },
        react_1.default.createElement(TextLink, { href: billingHistory }, children)));
};
var keys = {
    elecLabel: 'common.elecFuel',
    gasLabel: 'common.gasFuel',
    bothFuelsLabel: 'common.bothFuels',
    kwhLabel: 'common.kwhUnit',
    kwhFull: 'common.kwhFull',
    costLabel: 'common.costFull',
    costUnit: 'common.costUnit',
    title: 'usage.title',
    compareLabel: 'usage.compareLabel',
    prevNav: 'usage.prevNav',
    nextNav: 'usage.nextNav',
    dualElecWarning: 'usage.dualElecWarning',
    dataWarningTitle: 'usage.dataWarningTitle',
    dataWarningBody: 'usage.dataWarningBody',
    dailyViewTradMeterInfoTitle: 'usage.dailyViewTradMeterInfoTitle',
    dailyViewTradMeterInfoBody: 'usage.dailyViewTradMeterInfoBody',
    dataMissingForUnitWarningTitle: 'usage.dataMissingForUnitWarningTitle',
    dataMissingForUnitWarningBody: 'usage.dataMissingForUnitWarningBody',
    noCurrentDataInfoTitleDay: 'usage.noCurrentDataInfoTitleDay',
    noCurrentDataInfoTitleMonth: 'usage.noCurrentDataInfoTitleMonth',
    noCurrentDataInfoTitleYear: 'usage.noCurrentDataInfoTitleYear',
    noCurrentDataInfoBody: 'usage.noCurrentDataInfoBody',
    noCurrentDataInfoTradBody: 'usage.noCurrentDataInfoTradBody',
    loading: 'usage.loading',
    readingPrompt: 'usage.readingPrompt',
    genericReadingPrompt: 'usage.genericReadingPrompt',
    lastReading: 'usage.lastReading',
    lastElecReading: 'usage.lastElecReading',
    lastGasReading: 'usage.lastGasReading',
    topStatsCostsLabel: 'usage.topStatsCostsLabel',
    topStatsKwhLabel: 'usage.topStatsKwhLabel',
    topStatsTotalElecCost: 'usage.topStatsTotalElecCost',
    topStatsTotalGasCost: 'usage.topStatsTotalGasCost',
    topStatsTotalElecKwh: 'usage.topStatsTotalElecKwh',
    topStatsTotalGasKwh: 'usage.topStatsTotalGasKwh',
    dailyTablePeriodLabel: 'usage.dailyTablePeriodLabel',
    dailyTableBeforeMiddayLabel: 'usage.dailyTableBeforeMiddayLabel',
    dailyTableAfterMiddayLabel: 'usage.dailyTableAfterMiddayLabel',
    monthlyTablePeriodLabel: 'usage.monthlyTablePeriodLabel',
    yearlyTablePeriodLabel: 'usage.yearlyTablePeriodLabel',
    tableDisclosure: 'usage.tableDisclosure',
    tableTotal: 'usage.tableTotal',
    tableUsageLabel: 'usage.tableUsageLabel',
    tableCostLabel: 'usage.tableCostLabel',
    fuelLabel: 'usage.fuelLabel',
    unitLabel: 'usage.unitLabel',
    modalSubmit: 'usage.modalSubmit',
    modalTitle: 'usage.modalTitle',
    modalOpenButton: 'usage.modalOpenButton',
    controlsChargeDisclaimer: 'usage.controlsChargeDisclaimer',
    comparisonOptionNoComparison: 'usage.comparisonOptionNoComparison',
    comparisonOptionPreviousYear: 'usage.comparisonOptionPreviousYear',
    comparisonOptionOneMonthEarlier: 'usage.comparisonOptionOneMonthEarlier',
    comparisonOptionSameMonthLastYear: 'usage.comparisonOptionSameMonthLastYear',
    helpLinkBody: 'usage.helpLinkBody',
    miBannerFallbackHeading: 'usage.miBannerFallbackHeading',
    miBannerFallbackDescription: 'usage.miBannerFallbackDescription',
    yearTabTitle: 'usage.yearTabTitle',
    billingPeriodTabTitle: 'usage.billingPeriodTabTitle',
    monthTabTitle: 'usage.monthTabTitle',
    dayTabTitle: 'usage.dayTabTitle',
    skipChart: 'usage.skipChart',
    backToTopOfChart: 'usage.backToTopOfChart',
    summaryTitle: 'usage.summaryTitle',
    summarySmallPrint: 'usage.summarySmallPrint',
    summaryLink: 'usage.summaryLink',
    summaryNoData: 'usage.summaryNoData',
    summaryNoDataHeading: 'usage.summaryNoDataHeading',
    summaryNoDataMessage: 'usage.summaryNoDataMessage',
    feedbackPrompt: 'usage.feedbackPrompt',
    unsupportedMeterSetupPageTitle: 'usage.unsupportedMeterSetupPageTitle',
    unsupportedMeterSetupTitle: 'usage.unsupportedMeterSetupTitle',
    unsupportedMeterSetupText: 'usage.unsupportedMeterSetupText',
};
var defaultTranslations = (0, deepmerge_1.default)(core_1.translations, {
    en: {
        usage: {
            title: 'Your {{date}} energy use',
            compareLabel: 'Compare',
            prevNav: 'Navigate to your {{prevDate}} usage',
            nextNav: 'Navigate to your {{nextDate}} usage',
            dualElecWarning: '<P>You have more than one electricity supply. This usage graph shows only one of your supplies. Energy use and charges for all supplies are available on your bills.</P>',
            dataWarningTitle: 'Looks like we couldn’t find your usage data',
            dataWarningBody: '<P>We’ll take a look at this shortly, please try again later.</P>',
            dailyViewTradMeterInfoTitle: 'We don’t have data for this fuel',
            dailyViewTradMeterInfoBody: '<P>We can only display daily data for a smart meter</P>',
            dataMissingForUnitWarningTitle: 'Looks like we couldn’t find some of your usage data',
            dataMissingForUnitWarningBody: '<P>We’re missing some data for the selected unit, try another unit or period of time</P>',
            noCurrentDataInfoTitleDay: 'We don’t have any data for this day yet',
            noCurrentDataInfoTitleMonth: 'We don’t have any data for this month yet',
            noCurrentDataInfoTitleYear: 'We don’t have any data for this year yet',
            noCurrentDataInfoBody: '<P>Take a look at a previous date or come back again later.</P>',
            noCurrentDataInfoTradBody: '<P>We display your energy use over time based on previous meter readings, so it can take some time before your usage is displayed.</P>',
            loading: '<P>Loading...</P>',
            readingPrompt: '<P>We display your energy use over time based on previous meter readings. <Prompt>Get a clearer picture of what you’re using by <PromptLink>sending a meter reading</PromptLink>.</Prompt></P>',
            genericReadingPrompt: '<P>We display your energy use over time based on previous meter readings. <Prompt>Get a clearer picture of what you’re using by <PromptLink>sending a meter reading</PromptLink>.</Prompt></P>',
            lastReading: '<P>Your last meter reading was submitted on: <Strong><ReadingDate /></Strong></P>',
            lastElecReading: '<P>Your last electricity meter reading was submitted on: <Strong><ReadingElecDate /></Strong></P>',
            lastGasReading: '<P>Your last gas meter reading was submitted on: <Strong><ReadingGasDate /></Strong></P>',
            topStatsCostsLabel: '<ToDate>$t(common.costFull)</ToDate>',
            topStatsKwhLabel: '<ToDate>$t(common.kwhUnit)</ToDate>',
            topStatsTotalElecCost: 'Total $t(common.elecFuel) cost',
            topStatsTotalGasCost: 'Total $t(common.gasFuel) cost',
            topStatsTotalElecKwh: 'Total $t(common.elecFuel) $t(common.kwhUnit)',
            topStatsTotalGasKwh: 'Total $t(common.gasFuel) $t(common.kwhUnit)',
            dailyTablePeriodLabel: 'Time period',
            dailyTableBeforeMiddayLabel: 'Before midday',
            dailyTableAfterMiddayLabel: 'After midday',
            monthlyTablePeriodLabel: 'Day',
            yearlyTablePeriodLabel: 'Month',
            tableDisclosure: 'Table breakdown',
            tableTotal: 'Total',
            tableUsageLabel: 'Usage',
            tableCostLabel: 'Cost',
            fuelLabel: 'Fuel',
            unitLabel: 'Unit',
            modalSubmit: 'Apply',
            modalTitle: 'Switch View',
            modalOpenButton: 'Switch View',
            controlsChargeDisclaimer: '<P><Small>Energy use only - excludes standing charges, VAT and any other costs</Small></P>',
            comparisonOptionNoComparison: 'No comparison',
            comparisonOptionPreviousYear: 'Compare to previous year',
            comparisonOptionOneMonthEarlier: 'Compare to one month earlier',
            comparisonOptionSameMonthLastYear: 'Compare to same month last year',
            helpLinkBody: 'See how we calculate your usage',
            miBannerFallbackHeading: "We're making some small updates to our platform",
            miBannerFallbackDescription: "Updates are scheduled to take place over this weekend. If you're on a smart meter, you might not see any new usage on the charts until after we've finished.",
            yearTabTitle: 'Year',
            billingPeriodTabTitle: 'Billing Period',
            monthTabTitle: 'Month',
            dayTabTitle: 'Day',
            skipChart: 'Skip chart',
            backToTopOfChart: 'Back to top of chart',
            summaryTitle: "Your energy usage",
            summarySmallPrint: "<P><Small>Excludes standing charges, VAT and any other costs</Small></P>",
            summaryLink: "View my energy usage",
            summaryNoData: 'Your energy usage',
            summaryNoDataHeading: "<Heading4>No data available</Heading4>",
            summaryNoDataMessage: "<P>Sorry, we\u2019re having trouble showing this right now. Please check back later.</P>",
            feedbackPrompt: 'How easy is it to understand your usage?',
            unsupportedMeterSetupPageTitle: 'Usage',
            unsupportedMeterSetupTitle: "Your meter setup isn't supported",
            unsupportedMeterSetupText: "<P>Right now, we can't show a usage graph for your meter setup. We're working on improving this, but in the meantime you can see your energy consumption <UnsupportedMeterBillingLink>on your bills</UnsupportedMeterBillingLink>.</P>",
        },
    },
});
var defaultOptions = {
    keys: keys,
    defaultTranslations: defaultTranslations,
    components: {
        Prompt: Prompt,
        PromptLink: PromptLink,
        ReadingDate: ReadingDate,
        ReadingElecDate: ReadingElecDate,
        ReadingGasDate: ReadingGasDate,
        ToDate: ToDate,
        UnsupportedMeterBillingLink: UnsupportedMeterBillingLink,
    },
};
exports.defaultOptions = defaultOptions;
